import { call, put, takeLatest } from "redux-saga/effects";
import { TreatmentPlanTemplatesAPI } from "../../../api/treatmentPlansAPI";
import {
  GET_MEDICATION_TEMPLATE_ERROR,
  GET_MEDICATION_TEMPLATE_REQUEST,
  GET_MEDICATION_TEMPLATE_SUCCESS,
} from "../../actions";

function* workerGetSingleMedicationTemplate(action: {
  type: string;
  payload: {
    id: string;
  };
}): Generator<any> {
  try {
    const data: any = yield call(
      TreatmentPlanTemplatesAPI.getSingleMedicationTemplate,
      action.payload.id
    );
    yield put({
      type: GET_MEDICATION_TEMPLATE_SUCCESS,
      payload: {
        current: data
      }
    });
  } catch (error: any) {
    yield put({
      type: GET_MEDICATION_TEMPLATE_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherGetSingleMedicationTemplate() {
  yield takeLatest(GET_MEDICATION_TEMPLATE_REQUEST, workerGetSingleMedicationTemplate);
}
